import React from "react";
import "./featuredAnalysis.css";

const FeaturedAnalysisCards = () => {
    const data = [
        {
            title: "Diverse Industry Presence",
            description:
                "CG Power operates in EMS, Semiconductor, and Defence sectors, with expertise across industrial systems, power systems, railways, and consumer products.",
            icon: "🏭",
        },
        {
            title: "Major Semiconductor Investment",
            description:
                "Committed INR 7,600 crore to establish an OSAT facility in Sanand, Gujarat, targeting advanced and legacy semiconductor packages with a potential annual output of 4 billion+ units.",
            icon: "💾",
        },
        {
            title: "Strategic Semiconductor Acquisition",
            description:
                "Acquired a 55% stake in Renesas' Radio Frequency Components (RFC) business for INR 319 crore, strengthening semiconductor design and R&D capabilities.",
            icon: "📡",
        },
        {
            title: "Capacity Expansion",
            description:
                "Investing INR 688 crore to expand production across motors, power transformers, and distribution transformers, significantly increasing output in key facilities.",
            icon: "⚙️",
        },
        {
            title: "Railway and Infrastructure Focus",
            description:
                "Developed new railway products, including 40 kV lighting arrestors for Vande Bharat locomotives and a 16.5 MVA trackside auto transformer for Indian Railways.",
            icon: "🚆",
        },

        {
            title: "Battery Energy Storage Solutions",
            description:
                "Introduced Power Conversion Systems (PCS) for Battery Energy Storage (BESS), supporting renewable energy adoption and grid stability.",
            icon: "🔌",
        },
    ];

    return (
        <div className="analysis-container">
            <h2 className="analysis-title">
                <span className="highlight">FEATURED ANALYSIS</span> </h2>
            <h2 className="analysis-title"> CG Power and Industrial Solutions
            </h2>
            <p className="analysis-description">
                A comprehensive analysis of one of India's leading industrial solutions providers, showcasing strategic initiatives and market positioning.
            </p>

            <div className="cards">
                {data.map((item, index) => (
                    <div className="card" key={index}>
                        <div className="card-icon">{item.icon}</div>
                        <div className="card-content">
                            <h3 className="card-title">{item.title}</h3>
                            <p className="card-description">{item.description}</p>
                        </div>
                    </div>
                ))}
            </div>

            <div className="tags">

                <span className="tag">🔬 Product Expertise</span>
                <span className="tag">💰 Revenue Breakdown</span>
                <span className="tag">📋 Work Order</span>
                <span className="tag">🏗️ Capex</span>
                <span className="tag">🆕 New Products</span>
                <span className="tag">🚀 Emerging Opportunities</span>
                <span className="tag">🏛️ Policy/Sectoral Boost</span>
                <span className="tag">⚠️ Risks</span>
                <span className="tag">🤝 Partnerships</span>
            </div>

        </div>
    );
};

export default FeaturedAnalysisCards;
